"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferType = exports.DirectionType = exports.TransactionType = exports.StatusType = void 0;
var StatusType;
(function (StatusType) {
    StatusType["UNKNOWN"] = "UNKNOWN";
    StatusType["SUCCESS"] = "SUCCESS";
    StatusType["FAILED"] = "FAILED";
    StatusType["CANCELLED"] = "CANCELLED";
    StatusType["AWAITING_CONFIRMATIONS"] = "AWAITING_CONFIRMATIONS";
    StatusType["AWAITING_EXECUTION"] = "AWAITING_EXECUTION";
})(StatusType || (exports.StatusType = StatusType = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["TRANSFER"] = "Transfer";
    TransactionType["CREATION"] = "Creation";
    TransactionType["CANCELLATION"] = "Cancellation";
})(TransactionType || (exports.TransactionType = TransactionType = {}));
var DirectionType;
(function (DirectionType) {
    DirectionType["UNKNOWN"] = "UNKNOWN";
    DirectionType["INCOMING"] = "INCOMING";
    DirectionType["OUTGOING"] = "OUTGOING";
})(DirectionType || (exports.DirectionType = DirectionType = {}));
var TransferType;
(function (TransferType) {
    TransferType["NATIVE_TRANSFER"] = "NATIVE_TRANSFER";
    TransferType["FT_TRANSFER"] = "FT_TRANSFER";
    TransferType["NFT_TRANSFER"] = "NFT_TRANSFER";
})(TransferType || (exports.TransferType = TransferType = {}));
